import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import currencyFormatter, { Currency } from "@/common/CurrencyFormatter";

interface NewcomerPopupModalProperties {
    readonly unlimitedDiscountValue: number;
    readonly unlimitedDiscountCode: string;
    readonly limitedDiscountValue: number;
    readonly limitedDiscountCode: string;
    readonly limitedDiscountCodeAmount: number;
    readonly mode: "detail" | "general";
    readonly onAfterClose: () => void;
    readonly currency: Currency;
}

export default function NewcomerPopupModal({
    unlimitedDiscountValue,
    unlimitedDiscountCode,
    limitedDiscountValue,
    limitedDiscountCode,
    limitedDiscountCodeAmount,
    mode,
    onAfterClose,
    currency,
}: NewcomerPopupModalProperties): React.JSX.Element {
    const { t } = useTranslation("general");
    const [modalIsOpen, setModalIsOpen] = React.useState(true);

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition"
            closeTimeoutMS={150}
            onAfterClose={onAfterClose}
        >
            <div className="modal-content">
                <div className="modal-header empty">
                    <button type="button" className="close" onClick={closeModal}><i className="fa-solid fa-times"></i></button>
                </div>
                <div className="modal-body">
                    <div className="well well-transparent">
                        <div className="product-row">
                            {mode === "detail"
                                ? <p className="newcomer-heading fakeh3">{t("giveChanceToUnpackedGoods")}</p>
                                : <p className="newcomer-heading fakeh3">{t("orderAndJumpForJoy")}</p>}
                            <p className="newcomer-subheading">{t("chooseBestDiscount")}</p>
                            <div className="newcomer-modal-box-wrap general bigger-margin">
                                <div className="newcomer-modal-box-inner">
                                    <div className="newcomer-modal-box-heading">
                                        {t("discount")} <span
                                            className="red">{currencyFormatter.formatCurrencyWithSymbol(unlimitedDiscountValue, currency)}
                                        </span> {t("justBecause")}
                                        <span className="newcomer-validity"> {t("onAnything")}</span>
                                    </div>
                                    <div className="newcomer-modal-box-code first">
                                        <span className="newcomer-use-code">{t("useCode")}:</span>
                                        <span className="newcomer-code">{unlimitedDiscountCode}</span>
                                    </div>
                                    <div className="newcomer-modal-box-heading">
                                        {t("discount")} <span className="red">{currencyFormatter.formatCurrencyWithSymbol(limitedDiscountValue, currency)}</span> {t("justBecause")}
                                        <span
                                            className="newcomer-validity"> {t("onAnythingAbove")} {currencyFormatter.formatCurrencyWithSymbol(limitedDiscountCodeAmount, currency)}
                                        </span>
                                    </div>
                                    <div className="newcomer-modal-box-code second">
                                        <span className="newcomer-use-code">{t("useCode")}:</span>
                                        <span className="newcomer-code">{limitedDiscountCode}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="newcomer-modal-box-note"><i className="fa-solid fa-info-circle"></i>{t("enterCodeAtCheckout")}
                            </div>
                            <button type="button" className="btn btn-success pull-right" onClick={closeModal}>{t("goForIt")}</button>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
